import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useParams, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'

const EditContact = () => {

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [number, setNumber] = useState("");

    const { id } = useParams();

    const contacts = useSelector(state => state);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const currentContact = contacts.find(contact => contact.id === parseInt(id));

    useEffect(() => {
        if(currentContact) {
            setName(currentContact.name);
            setEmail(currentContact.email);
            setNumber(currentContact.number);
        }
        
    }, [currentContact]);


    const handleSubmit = (e) => {
        e.preventDefault();
    
        const checkEmail = contacts.find(
          (contact) => contact.id !== parseInt(id) && contact.email === email
        );
    
        const checkNumber = contacts.find(
          (contact) => contact.id !== parseInt(id) && contact.number === parseInt(number)
        );
    
        if(!name || !email || !number || !name) {
          return toast.warning("Please fill in all fields !")
        }
    
        if(checkEmail) {
          return toast.error("This email already exist !")
        }
    
        if(checkNumber) {
          return toast.error("This number already exist !")
        }
    
        const data = {
          id: parseInt(id),
          name,
          email,
          number
        }
    
        dispatch({type: "UPDATE_CONTACT", payload: data});
        toast.success("Student update successfully !!");
        navigate("/");
    }
    

    return (
        <div className="container">

            {currentContact ? (
                <>  
                    <h1 className="display-3 my-5 text-center text-light">
                        {/* Edit Student {id} */} Edit Contact 
                    </h1>
                    <div className="row">
                        <div className="col-md-6 shadow mx-auto p-5">
                            <form onSubmit={handleSubmit}>
                                <div className="form-group">
                                    <input type="text" placeholder="Name" 
                                    className="form-control" value={name} onChange={e => setName(e.target.value)} />
                                </div> 

                                <div className="form-group my-3">
                                    <input type="email" placeholder="Email" 
                                    className="form-control" value={email} onChange={e => setEmail(e.target.value)} />
                                </div>

                                <div className="form-group mb-3">
                                    <input type="number" placeholder="Phone number" 
                                    className="form-control" value={number} onChange={e => setNumber(e.target.value)} />
                                </div>

                                <div className="form-group d-flex">
                                    <input
                                    className="btn btn-dark me-2"
                                    type="submit"
                                    value="Update Contact"
                                    />
                                    <Link
                                        to="/" className="btn btn-danger">
                                        Cancel
                                    </Link>
                                </div>
                            </form>
                        </div>
                    </div>
                </>  
            ): (
                <h1 className="display-3 my-5 text-center">
                    Edit contact with id {id} not exists
                </h1>
            )}

        </div>
    )
}

export default EditContact